export async function compressFile(file: File) {
  const compressionStream = new CompressionStream("gzip");
  const compressedStream = file.stream().pipeThrough(compressionStream);

  // 스트리밍 방식으로 메모리 효율적 압축
  const response = new Response(compressedStream);
  return await response.blob();
}

// 파일 타입 결정
export const getFileType = (file: File): "pdf" | "csv" | "image" => {
  if (file.type.startsWith("image/")) return "image";
  if (
    file.type === "application/pdf" ||
    file.name.toLowerCase().endsWith(".pdf")
  )
    return "pdf";
  if (file.type === "text/csv" || file.name.toLowerCase().endsWith(".csv"))
    return "csv";
  return "csv"; // 기본값
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const checkFileExtensions = (
  files: FileList | null,
  allowedExtensions: string[]
): boolean => {
  // 파일이 없는 경우 
  if (!files) return false;

  // FileList를 배열로 변환 후 허용되지 않은 확장자를 가지고 있는지 검사
  return Array.from(files).some(
    (file) => 
      // 파일 이름에서 마지막 '.'뒤 문자열을 확장자로 가져오고 소문자로 변환
      !allowedExtensions.includes(file.name.split(".").pop()?.toLowerCase() || "")
  );
};
